import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { IThunkApi } from '../timesheet/timesheetSlice';
import fetchTimeliveAPI from '../../common/fetchTimeliveAPI';
import fetchAPI from '../../common/fetchAPI';

interface TimeOffConfirmationState {
    show: boolean;
    timeOffDate: Date | null;
    timeOffTypeName: string;
    resourceData: any;
    clickedDate: Date | null;
    isWeekend?: boolean;
}
export interface SchedulerStateClass {
    status: 'idle' | 'loading' | 'failed';
    loading: boolean;
    schedulerMonth: any;
    projectWithMilestone: any;
    projectEmployees: any;
    isOpenModal: boolean;
    isOpenProjectModal: boolean;
    projectData: any;
    showAssignment: boolean;
    assignmentModalData: any;
    monthStartDate: Date;
    monthEndDate: Date;
    showMilestone: boolean;
    refreshData: boolean;
    tabs: string;
    employeeId: any;
    IsAdd: boolean;
    IsDelete: boolean;
    IsEdit: boolean;
    IsList: boolean;
    timeOffConfirmation: TimeOffConfirmationState;
    milestonePermissionsValues: any;
    currentPage: any;
    pageNo: number;
    pageSize: number;
    totalItems: number;
    startRec: number;
    search: any;
}
const initialState: SchedulerStateClass = {
    status: 'idle',
    loading: false,
    schedulerMonth: null,
    projectWithMilestone: [],
    projectEmployees: [],
    isOpenModal: false,
    projectData: null,
    showAssignment: false,
    assignmentModalData: null,
    monthStartDate: new Date(),
    monthEndDate: new Date(),
    showMilestone: false,
    refreshData: false,
    tabs: 'resource',
    isOpenProjectModal: false,
    employeeId: 0,
    IsAdd: false,
    IsDelete: false,
    IsEdit: false,
    IsList: false,
    milestonePermissionsValues: null,
    currentPage: 1,
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    startRec: 0,
    search: '',
    timeOffConfirmation: {
        show: false,
        timeOffDate: null,
        timeOffTypeName: '',
        resourceData: null,
        clickedDate: null,
        isWeekend: false
    } as TimeOffConfirmationState
}

export const GetAccountProjectSchedulerWithMilestone = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'scheduler/GetAccountProjectSchedulerWithMilestone',
        async (arg, thunkApi) => {
            try {
                const { StartDate, EndDate, pageNo, pageSize, searchText } = arg;
                if (StartDate && EndDate) {
                    const response = await fetchTimeliveAPI(`api/Scheduler/GetAccountProjectSchedulerWithMilestone/${StartDate}/${EndDate}/${pageNo}/${pageSize}?searchText=${searchText}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetAccountProjectEmployeeEvents = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'scheduler/GetAccountProjectEmployeeEvents',
        async (arg, thunkApi) => {
            try {
                if (arg) {
                    const { AccountProjectId, StartDate, EndDate } = arg;
                    const response = await fetchTimeliveAPI(`api/Scheduler/GetAccountProjectEmployeeEvents/${AccountProjectId}/${StartDate}/${EndDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )
export const SaveAccountProjectMilestone = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'scheduler/SaveAccountProjectMilestone',
        async (arg, thunkApi) => {
            try {
                if (arg) {
                    const response = await fetchTimeliveAPI(`api/Milestone`, 'POST', arg, true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const UpdateAccountProjectMilestone = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'scheduler/UpdateAccountProjectMilestone',
        async (arg, thunkApi) => {
            try {
                if (arg) {
                    const response = await fetchTimeliveAPI(`api/Milestone/UpdateAccountProjectMilestone/${arg?.AccountProjectMilestoneId}`, 'PUT', arg, true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )
export const GetAccountEmployeeScheduler = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'scheduler/GetAccountEmployeeScheduler',
        async (arg, thunkApi) => {
            try {
                if (arg) {
                    const { StartDate, EndDate, pageNo, pageSize, searchText } = arg;
                    const response = await fetchTimeliveAPI(`api/Scheduler/GetAccountEmployeeScheduler/${StartDate}/${EndDate}/${pageNo}/${pageSize}?searchText=${searchText}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetAccountEmployeeProjectEvents = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'scheduler/GetAccountEmployeeProjectEvents',
        async (arg, thunkApi) => {
            try {
                if (arg) {
                    const { AccountEmployeeId, StartDate, EndDate } = arg;
                    const response = await fetchTimeliveAPI(`api/Scheduler/GetAccountEmployeeProjectEvents/${AccountEmployeeId}/${StartDate}/${EndDate}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const DeleteAccountEmployeeScheduler = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'scheduler/DeleteAccountEmployeeScheduler',
        async (arg, thunkApi) => {
            try {
                if (arg) {
                    const { accountEmployeeSchedulerId, accountProjectTaskId } = arg;
                    const response = await fetchTimeliveAPI(`api/Scheduler/DeleteAccountEmployeeScheduler/${accountEmployeeSchedulerId}/${accountProjectTaskId}`, 'DELETE', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetAccountEmployeeProjectsWithoutAllocations = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'Project/GetAccountEmployeeProjectsWithoutAllocations',
        async (arg, thunkApi) => {
            try {
                if (arg) {
                    const response = await fetchTimeliveAPI(`api/Project/GetAccountEmployeeProjectsWithoutAllocations/${arg}`, 'GET', "", true);
                    if (response.status !== 200) {
                        return thunkApi.rejectWithValue((response.statusText))
                    }
                    const json = await response.json();
                    return json.Data;
                }
            } catch (err) {
                thunkApi.rejectWithValue(err)
            }
        }
    )

export const GetEmployeeSchedulerCapacity = createAsyncThunk<any, void, IThunkApi>(
    'scheduler/GetEmployeeSchedulerCapacity',
    async (arg, thunkApi) => {
        try {
            const response = await fetchTimeliveAPI(`api/Scheduler/GetEmployeeSchedulerCapacity`, 'GET', "", true);
            if (response.status !== 200) {
                return thunkApi.rejectWithValue((response.statusText))
            }
            const json = await response.json();
            return json.Data;
        } catch (error) {
            thunkApi.rejectWithValue(error);
        }
    }
)

export const UpdateEmployeeSchedulerCapacity = createAsyncThunk<any, any, IThunkApi>(
    'scheduler/UpdateEmployeeSchedulerCapacity',
    async (arg, thunkApi) => {
        try {
            if (arg) {
                const { SystemEmployeeSchedulerCapacityId } = arg
                const response = await fetchTimeliveAPI(`api/Scheduler/UpdateEmployeeSchedulerCapacity/${SystemEmployeeSchedulerCapacityId}`, 'PUT', arg, true);
                if (response.status !== 200) {
                    return thunkApi.rejectWithValue((response.statusText))
                }
                const json = await response.json();
                return json.Data;
            }
        } catch (error) {
            thunkApi.rejectWithValue(error);
        }
    }
)

export const GetPermissionOfSchedule = createAsyncThunk
    <
        any,
        any,
        IThunkApi
    >
    (
        'PagePermission/v2/getPagePermissions',
        async (arg, thunkApi) => {
            const { accessToken } = thunkApi.getState().globalState
            const response = await fetchAPI('api/v2/PagePermission/PagePermissions/' + arg, 'GET', '', true, accessToken);
            const json = await response.json();
            return json;
        }
    )

export const schedulerSlice = createSlice({
    name: 'scheduler',
    initialState: initialState,
    reducers: {
        UpdateSchedulerMonth: (state, action) => {
            state.schedulerMonth = action.payload;
        },
        UpdateToShowModal: (state, action) => {
            state.isOpenModal = action.payload?.flag;
            state.projectData = action.payload?.resource;
        },
        UpdateToShowProjectsModal: (state, action) => {
            state.isOpenProjectModal = action.payload?.flag;
            state.employeeId = action.payload?.employeeId;
        },
        ShowAssignmentModal: (state, action) => {
            state.showAssignment = action.payload?.flag;
            state.assignmentModalData = action.payload?.ShowAssignmentModal;
        },
        ShowTimeOffConfirmationModal: (state, action) => {
            state.timeOffConfirmation = action.payload;
        },
        CloseTimeOffConfirmationModal: (state) => {
            state.timeOffConfirmation = {
                show: false,
                timeOffDate: null,
                timeOffTypeName: '',
                resourceData: null,
                clickedDate: null
            };
        },
        UpdateMonthDate: (state, action) => {
            state.monthStartDate = action.payload.StartDate;
            state.monthEndDate = action.payload.EndDate;
        },
        UpdateShowMilestone: (state, action) => {
            state.showMilestone = action.payload;
        },
        RefreshScheduler: (state, action) => {
            state.refreshData = action.payload;
        },
        updateTabs: (state, action) => {
            state.tabs = action.payload;
        },
        updateMilestonePermissions: (state, action) => {
            state.milestonePermissionsValues = action.payload;
        },
        updatePagination: (state, action) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAccountProjectSchedulerWithMilestone.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(GetAccountProjectSchedulerWithMilestone.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
                state.projectWithMilestone = action.payload;
            })
            .addCase(GetAccountProjectSchedulerWithMilestone.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(GetAccountProjectEmployeeEvents.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(GetAccountProjectEmployeeEvents.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
                state.projectEmployees = action.payload;
            })
            .addCase(GetAccountProjectEmployeeEvents.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(UpdateAccountProjectMilestone.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(UpdateAccountProjectMilestone.fulfilled, (state, action) => {
                state.status = 'idle';
            })
            .addCase(UpdateAccountProjectMilestone.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(SaveAccountProjectMilestone.pending, (state, action) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(SaveAccountProjectMilestone.fulfilled, (state, action) => {
                state.status = 'idle';
            })
            .addCase(SaveAccountProjectMilestone.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(GetAccountEmployeeScheduler.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(GetAccountEmployeeScheduler.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
            })
            .addCase(GetAccountEmployeeScheduler.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(GetAccountEmployeeProjectEvents.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(GetAccountEmployeeProjectEvents.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
            })
            .addCase(GetAccountEmployeeProjectEvents.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(DeleteAccountEmployeeScheduler.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(DeleteAccountEmployeeScheduler.fulfilled, (state) => {
                state.status = 'idle';
                state.loading = false;
            })
            .addCase(DeleteAccountEmployeeScheduler.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(GetAccountEmployeeProjectsWithoutAllocations.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(GetAccountEmployeeProjectsWithoutAllocations.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
            })
            .addCase(GetAccountEmployeeProjectsWithoutAllocations.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(GetEmployeeSchedulerCapacity.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(GetEmployeeSchedulerCapacity.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
            })
            .addCase(GetEmployeeSchedulerCapacity.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(UpdateEmployeeSchedulerCapacity.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(UpdateEmployeeSchedulerCapacity.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
            })
            .addCase(UpdateEmployeeSchedulerCapacity.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
            .addCase(GetPermissionOfSchedule.pending, (state) => {
                state.status = 'loading';
                state.loading = true;
            })
            .addCase(GetPermissionOfSchedule.fulfilled, (state, action) => {
                state.status = 'idle';
                state.loading = false;
                state.IsAdd = action.payload.IsAdd;
                state.IsEdit = action.payload.IsEdit;
                state.IsDelete = action.payload.IsDelete;
                state.IsList = action.payload.IsList;
            })
            .addCase(GetPermissionOfSchedule.rejected, (state) => {
                state.status = 'failed';
                state.loading = false;
            })
    }
})

export const { UpdateSchedulerMonth, UpdateToShowModal, ShowTimeOffConfirmationModal, CloseTimeOffConfirmationModal, ShowAssignmentModal, UpdateMonthDate, UpdateToShowProjectsModal, UpdateShowMilestone, RefreshScheduler, updateTabs, updateMilestonePermissions, updatePagination, setPageSize } = schedulerSlice.actions;
export const schedulerState = (state: RootState) => state.scheduler;
export default schedulerSlice.reducer